<template>
  <div>
    <label>{{ label }}</label>
    <br /><br />
    <label
      class="fileUpload"
      :class="{ 'drag-over': dragging }"
      @dragenter="handleDragEnter"
      @dragleave="handleDragLeave"
      v-if="mostrarFileUpload"
      for="inputFile"
      id="drag-drop-zone"
      @drop="handleFileDrop"
      @dragover.prevent
    >
      <svg
        viewBox="0 0 260 260"
        preserveAspectRatio="xMidYMid meet"
        focusable="false"
        aria-hidden="true"
        style="
          pointer-events: none;
          display: inline-block;
          width: 1.3rem;
          height: 1.3rem;
          overflow: hidden;
          vertical-align: middle;
          line-height: 1.3rem;
          margin-right: 0.65rem;
          pointer-events: none;
        "
      >
        <path
          class="a25b483c-4784-4cd4-8529-ecd112f76590"
          d="M10 130A120 120 0 1 0 130 10 120 120 0 0 0 10 130Zm182-18.3L177.7 126l-37.4-37.5.3 121.6L121 190V88.2l-38.4 38.2-14.4-14.3L130.3 50Z"
          fill="#1973B8"
        ></path>
      </svg>
      <span id="adjuntarArchivo"> Adjuntar archivo</span>
      <span id="arrastrarSoltar">o arrastrar y soltar acá</span>
    </label>

    <input
      type="file"
      id="inputFile"
      @change="handleFileInput"
      :accept="accept"
      :multiple="multiple"
      ref="fileInput"
    />
    <ul class="fileList" v-if="files.length">
      <li v-for="(file, index) in files" :key="index">
        <span id="fileName">{{ file.name }} </span>
        <span id="fileSize">{{ formatFileSize(file.size) }}</span>
        <button
          class="svg-button"
          id="buttonEliminar"
          @click="removeFile(index)"
          @click.prevent="noRefresh()"
        >
          <svg
            viewBox="0 0 260 260"
            preserveAspectRatio="xMidYMid meet"
            focusable="false"
            aria-hidden="true"
            style="pointer-events: none; display: block; width: 2rem; height: : 2rem; overflow: hidden;"
          >
            <g data-name="Trash">
              <path
                data-name="Icon"
                class="b9230f9b-0994-4948-9561-f88b7e56996e"
                d="M50 40h40v-9.91A10.08 10.08 0 0 1 100 20h60a10 10 0 0 1 10 10.09V40h60v30h-20v160.08a9.94 9.94 0 0 1-10 9.92H60a10 10 0 0 1-10-9.92V70H30V40Zm50 170v-80H80v60Zm40 0v-80h-20v60Zm40 0v-80h-20v60Z"
                fill="#004481"
              ></path>
            </g>
          </svg>
        </button>
      </li>
    </ul>
    <div
      style="display: flex; align-items: flex-start; margin-top: 10px"
      v-if="mostrarErrorFileLength"
    >
      <svg
        viewBox="0 0 260 260"
        preserveAspectRatio="xMidYMid meet"
        focusable="false"
        aria-hidden="true"
        style="
          pointer-events: none;
          width: 1.75rem;
          height: 1.75rem;
          overflow: hidden;
          margin-right: 0.5rem;
          margin-bottom: 0;
        "
        fill="#FF0000"
      >
        <path
          class="e2361b35-b7b0-44bb-ad69-27f39c087be8"
          d="M238.82 228.9 135.6 24.58c-3.1-6.11-8.1-6.11-11.2 0L21.18 228.9c-3.1 6.1.1 11.1 7.11 11.1h203.42c7.01 0 10.21-5 7.11-11.1ZM120 90l20 20v60h-20Zm10 130a15 15 0 1 1 15-15 15 15 0 0 1-15 15Z"
        ></path>
      </svg>
      <span>
        El nombre del archivo seleccionado supera los
        {{ fileLength }} caracteres permitidos. Editalo o seleccioná otro
        archivo que tenga un nombre más corto.
      </span>
    </div>
    <div
      style="display: flex; align-items: flex-start; margin-top: 10px"
      v-if="mostrarErrorMaxSize"
    >
      <svg
        viewBox="0 0 260 260"
        preserveAspectRatio="xMidYMid meet"
        focusable="false"
        aria-hidden="true"
        style="
          pointer-events: none;
          width: 1.23rem;
          height: 1.23rem;
          overflow: hidden;
          margin-right: 0.5rem;
          margin-bottom: 0;
        "
        fill="#FF0000"
      >
        <path
          class="e2361b35-b7b0-44bb-ad69-27f39c087be8"
          d="M238.82 228.9 135.6 24.58c-3.1-6.11-8.1-6.11-11.2 0L21.18 228.9c-3.1 6.1.1 11.1 7.11 11.1h203.42c7.01 0 10.21-5 7.11-11.1ZM120 90l20 20v60h-20Zm10 130a15 15 0 1 1 15-15 15 15 0 0 1-15 15Z"
        ></path>
      </svg>
      <span>
        El archivo seleccionado pesa mas de {{ maxSize / 1024 / 1024 }}MB, por
        favor seleccioná un archivo de menor peso.
      </span>
    </div>
    <div
      style="display: flex; align-items: flex-start; margin-top: 10px"
      v-if="mostrarErrorExtension"
    >
      <svg
        viewBox="0 0 260 260"
        preserveAspectRatio="xMidYMid meet"
        focusable="false"
        aria-hidden="true"
        style="
          pointer-events: none;
          width: 1.6rem;
          height: 1.6rem;
          overflow: hidden;
          margin-right: 0.5rem;
          margin-bottom: 0;
        "
        fill="#FF0000"
      >
        <path
          class="e2361b35-b7b0-44bb-ad69-27f39c087be8"
          d="M238.82 228.9 135.6 24.58c-3.1-6.11-8.1-6.11-11.2 0L21.18 228.9c-3.1 6.1.1 11.1 7.11 11.1h203.42c7.01 0 10.21-5 7.11-11.1ZM120 90l20 20v60h-20Zm10 130a15 15 0 1 1 15-15 15 15 0 0 1-15 15Z"
        ></path>
      </svg>
      <span>
        El formato del archivo debe ser {{ formatFileExtensions(accept) }} por
        favor seleccioná un archivo diferente.
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "FileUpload",
  props: {
    label: {
      type: String,
      default: "Archivo (Opcional)"
    },
    accept: {
      type: String,
      default: ".jpg,.png,.gif,.pdf,.doc,.docx,.txt"
    },
    multiple: {
      type: Boolean,
      default: false
    },
    maxSize: {
      type: Number,
      default: 2 * 1024 * 1024 // 2MB
    },
    fileLength: {
      type: Number,
      default: 75
    }
  },
  components: {},
  data() {
    return {
      mostrarFileUpload: true,
      mostrarErrorMaxSize: false,
      mostrarErrorExtension: false,
      mostrarErrorFileLength: false,
      dragging: false,
      files: [],
      fileName: "",
      fileBase64: ""
    };
  },
  methods: {
    noRefresh() {},
    handleDragEnter() {
      this.dragging = true;
    },
    handleDragLeave() {
      this.dragging = false;
    },
    handleFileDrop(e) {
      // Cuando se arrastra un archivo
      e.preventDefault();
      const file = e.dataTransfer.files[0];
      this.handleFileUpload(file);
      this.dragging = false;
    },
    handleFileInput(event) {
      // Cuando se clickea para agregar un archivo
      const file = event.target.files[0];
      this.handleFileUpload(file);
    },
    async handleFileUpload(file) {
      this.files = [];
      if (!this.isFileLengthAllowed(file)) {
        // Si el archivo no tiene una extension permitida se muestra mensaje de error
        this.$refs.fileInput.value = "";
        this.$emit("file-length-exceeded", file);
        this.mostrarErrorMaxSize = false;
        this.mostrarErrorExtension = false;
        this.mostrarErrorFileLength = true;
      } else if (!this.isFileTypeAllowed(file)) {
        // Si el archivo no tiene una extension permitida se muestra mensaje de error
        this.$refs.fileInput.value = "";
        this.$emit("file-size-exceeded", file);
        this.mostrarErrorMaxSize = false;
        this.mostrarErrorFileLength = false;
        this.mostrarErrorExtension = true;
      } else if (!this.isFileSizeAllowed(file)) {
        // Si el es muy pesado se muestra mensaje de error
        this.$refs.fileInput.value = "";
        this.$emit("file-size-exceeded", file);
        this.mostrarErrorFileLength = false;
        this.mostrarErrorExtension = false;
        this.mostrarErrorMaxSize = true;
      } else {
        // Si es un archivo permitido se envia
        const base64 = await this.readAsDataURL(file);
        const fileData = {
          fileName: file.name,
          fileBase64: base64
        };
        this.$emit("fileChange", fileData);
        this.files.push(file);
        this.mostrarFileUpload = false;
        this.mostrarErrorMaxSize = false;
        this.mostrarErrorExtension = false;
        this.mostrarErrorFileLength = false;
      }

      this.$emit("input", this.files);
    },

    async readAsDataURL(file) {
      const reader = new FileReader();
      return new Promise((resolve, reject) => {
        reader.onload = () => {
          resolve(reader.result.split(",")[1]);
        };
        reader.onerror = () => {
          reject(reader.error);
        };
        reader.readAsDataURL(file);
      });
    },
    removeFile(index) {
      this.files.splice(index, 1);
      this.fileName = "";
      this.fileBase64 = "";
      this.$emit("input", this.files);
      document.getElementById("inputFile").value = "";
      this.mostrarFileUpload = true;
    },
    formatFileSize(size) {
      const units = ["B", "KB", "MB", "GB", "TB"];
      let i = 0;
      while (size >= 1024 && i < units.length - 1) {
        size /= 1024;
        i++;
      }
      return `${Math.round(size * 100) / 100} ${units[i]}`;
    },
    isFileTypeAllowed(file) {
      const allowedTypes = this.accept.split(",");
      const fileType = file.type || "";
      const fileName = file.name || "";
      const fileExtension = fileName.slice(fileName.lastIndexOf(".") + 1);
      return allowedTypes.some(
        type => type.trim() === fileType || type.trim() === `.${fileExtension}`
      );
    },
    isFileLengthAllowed(file) {
      return file.name.length <= this.fileLength;
    },
    isFileSizeAllowed(file) {
      return file.size <= this.maxSize;
    },
    formatFileExtensions(str) {
      const extensions = str.split(",");
      const lastExtension = extensions.pop();
      const formattedExtensions = extensions.join(", ") + " o " + lastExtension;
      return formattedExtensions.replace(/,/g, ", ").replace(/\.(\w+)/g, ".$1");
    }
  }
};
</script>
<style scoped>
.fileUpload {
  border: 2px dashed #bdbdbd;
  padding: 20px;
  text-align: left;
  color: #1973b8;
  display: block;
  cursor: pointer;
  transition: 0.15s;
}

.fileUpload:hover {
  border: 2px dashed #043263;
  color: #043263;
}

.fileList {
  list-style: none;
  padding-inline-start: 0px;
}

#inputFile {
  display: none;
}

#fileName {
  color: #004481;
  font-weight: 600;
}

#adjuntarArchivo {
  display: inline-block;
  vertical-align: middle;
  line-height: 1.3rem;
  pointer-events: none;
}

#arrastrarSoltar {
  font-family: BentonSansBBVA-Light, Helvetica, Arial, sans-serif;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  color: grey;
  font-style: italic;
  display: inline-block;
  vertical-align: middle;
  line-height: 1.3rem;
  margin-left: 0.3rem;
  pointer-events: none;
}

.svg-button {
  background-color: transparent;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  width: 1.5rem;
  height: 1.5rem;
  float: right;
}

.svg-button svg {
  width: 100%;
  height: 100%;
}

.drag-over {
  border: 2px dashed #043263;
  background-color: #d4edfc;
}
</style>
